import { type DateInputProps } from '@mantine/dates';
import { DateInput } from 'src/common/components/date/DateInput';
import { FIELD_STYLES } from './InputWithLabel';

export function DateInputWithLabel({ ...props }: DateInputProps) {
  return <DateInput {...props} styles={FIELD_STYLES} />;
}
